import _ from 'lodash';

import { ApplyCycleMenuFieldEnum as Fields } from 'Common/FieldEnum';

export const NEW_MODIFIER = '_new';
export const MENU_OPTION_CYCLE_MENU = 'MENU_OPTION_CYCLE_MENU';
export const MENU_OPTION_CYCLE_MENU_NEW =
  'MENU_OPTION_CYCLE_MENU' + NEW_MODIFIER;
export const MENU_OPTION_CALENDAR = 'MENU_OPTION_CALENDAR';
export const MENU_OPTION_LIST_MENUS = 'MENU_OPTION_LIST_MENUS';
export const MENU_OPTION_TEMPLATE_MENUS = 'MENU_OPTION_TEMPLATE_MENUS';
export const MENU_OPTION_APPLIED_MENUS = 'MENU_OPTION_APPLIED_MENUS';

export const MESSAGES = {
  RECIPE_ALREADY_ADDED: {
    Title: 'Error',
    Message: 'Recipe has already been added to that day.',
  },
  ADD_RECIPE_MULTIPLE_ALREADY_ADDED: {
    Title: 'Error',
    Message: 'Recipe has already been added to one of the selected days.',
  },
  FETCH_ERROR: {
    Title: 'Error',
    Message: 'An error occurred while retrieving data. Please try again',
  },
  GET_CYCLE_MENU_ERROR: {
    Title: 'Error',
    Message: 'An error occurred while loading the menu items.',
  },
  APPLY_CYCLE_MENU_ERROR: {
    Title: 'Error',
    Message: 'An error occurred while applying the cycle menu.',
  },
  UN_APPLY_CYCLE_MENU_ERROR: {
    Title: 'Error',
    Message: 'An error occurred while un-applying the cycle menu.',
  },
  CHECK_CYCLE_MENU_ERROR: {
    Title: 'Error',
    Message:
      'An error occurred while checking to see if the cycle menu has been applied.',
  },
  ANALYZE_CYCLE_MENU_ERROR: {
    Title: 'Error',
    Message: 'An error occurred while analyzing the cycle menu.',
  },
  GET_APPLIED_MENUS_ERROR: {
    Title: 'Error',
    Message: 'An error occurred while retrieving the applied menus.',
  },
  ADD_RECIPE_INVALID_SERVING_SIZE: {
    Title: 'Error',
    Message: 'Cannot add a recipe that has a serving size of 0.',
  },
  DELETE_APPLIED_CYCLE_MENU_ERROR: {
    Title: 'Error',
    Message: 'An error occurred while deleting the applied cycle menu.',
  },
  PASTE_RECIPE_ERROR: {
    Title: 'Error',
    Message: 'Some recipes could not be pasted for the following reasons: ',
  },
  GET_SCHOOL_CALENDAR_ERROR: {
    Title: 'Error',
    Message: 'An error occurred while fetching the school calendar',
  },
  GET_CYCLE_MENU_SITES_ERROR: {
    Title: 'Error',
    Message: 'An error occurred while fetching sites for the cycle menu',
  },
};

export const DIGITAL_MENU_SUITE_OPTIONS = [
  Fields.PublishToWebsite,
  Fields.PublishToOMD,
  Fields.PublishToMobileMenus,
  Fields.PublishToDigitalDisplays,
  Fields.PublishToOnlineOrdering,
  Fields.PublishToGoingGreen,
];

export const ANALYSIS_DAYS_OPTIONS = _.range(3, 8).map((day) => ({
  key: day,
  value: day,
  text: `${day} Days`,
}));

export const MANAGE_MENU_PAGE_VIEWS = {
  CYCLE_MENU: '0',
  APPLIED_MENU: '1',
  CALENDAR_MENU: '2',
  LIST_MENU: '3',
  TEMPLATE_MENU: '4',
};

export const EDIT_MENU_QUERYSTRINGS = {
  VIEW: 'view',
  ANALYSIS_DAYS: 'days',
  START_DATE: 'start',
  END_DATE: 'end',
  SITE_ID: 'site',
  NUTRITION_STANDARD_ID: 'standard',
  DESCRIPTION: 'desc',
};

export const EDIT_MENU_TYPES = {
  CYCLE_MENU: 0,
  APPLIED_MENU: 1,
};

export const FIND_MODES = {
  REPLACE: 'REPLACE',
  REMOVE: 'REMOVE',
};



// WEBPACK FOOTER //
// ./src/pages/managemenu/helpers/Constants.js